import { Button } from "@mui/material";


const PageNotFound = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <h1
        style={{
          color: "white",
          fontSize: "5rem",
        }}
      >404 - Pagina no encontrada
      </h1>
      <h6>
        <span
          style={{
            color: "white",
            fontSize: "2rem",
          }}
        >
          Tranquilo, solo dale clic al botón e inicia sesión de nuevo.
        </span>
      </h6>
      <Button
        variant="contained"
        sx={{ backgroundColor: "primary.gold" }}
        href="/login"
        style={{
          margin: "1rem",
        }}
      >
        Volver a inicio
      </Button>
    </div>
  );
}

export default PageNotFound;